import { Storage } from './storage';

export class InMemoryStorage implements Storage {
  private storage = new Map<string, string>();

  clear(): void {
    this.storage.clear();
  }

  getItem(key: string): string | null {
    if (this.storage.has(key)) {
      return this.storage.get(key);
    }

    return null;
  }

  removeItem(key: string): void {
    this.storage.delete(key);
  }

  setItem(key: string, value: string): void {
    this.storage.set(key, value);
  }
}
